export const WEEK_DAYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday'
]

export const AB_DAYS = [
  'a',
  'b',
  'as',
  'bs'
]

export const ED_COLORS = {
  MAIN: {
    HEX: '#2BB2AC' 
  }
}

export const POPUP_MENU_EVENTS = {
  CLOSE_POPUP_MENU: 'CLOSE_POPUP_MENU'
}